import styled from "styled-components";

export const MobilePositionCreateTopUpStyled = styled.div`
    padding: 24px 16px 16px;
    background: var(--color-neutral-20);
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 8px;

    p {
        text-align: center;
        margin-bottom: 0;
        margin-top: 16px;
        font-size: 14px;
        color: var(--color-white-95);
    }

    button {
        margin-top: 40px;
        width: 100%;
    }
`;

export const MobilePositionCreateTopUpIconStyled = styled.div`
    display: flex;
    flex-direction: column;
    
    img {
        height: 56px;
        width: 56px;
    }
`;
